// export const ENDPOINT = "http://216.219.84.38:8383/api/";
// export const WEB_URL = "http://216.219.84.38:6262/";
// export const IMAGEBASEURL = "http://216.219.84.38:6969/CLOUD_PMS";

// export const ENDPOINT = "http://69.169.101.31:5051/api/";
// export const WEB_URL = "http://69.169.101.31:5050/";
// export const IMAGEBASEURL = "http://69.169.101.31:5004/CLOUD_ITMMGT";

export const ENDPOINT = "https://api-inventory.eskaiy.dev/api/";
export const WEB_URL = "https://inventory.eskaiy.dev/";
export const IMAGEBASEURL = "https://fileserver.eskaiy.dev/CLOUD_ITMMGT";